import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class PersonCommunicationService extends BaseService {
	constructor() {
		super('/PersonCommunication');
	}


	public getAllByFilter(filter: PersonCommunicationFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class PersonCommunicationFilter extends BaseFilter {
	constructor(idPerson?: number | null, idCommunication?: number | null) {
		super();
		this._idCommunication = idCommunication;
		this._idPerson = idPerson;
		
	}

	private _idCommunication?: number | null;
	private _idPerson?: number | null;
	

	public getAllParams(): {} {
	
		let data = Object.assign({},
			(this._idPerson != null ? { IdPerson: this._idPerson } : {}),
			(this._idCommunication != null ? { IdCommunication: this._idCommunication } : {})
		);
	
		return data;
	};
}